import { render, staticRenderFns } from "./ModalFrameBasic.vue?vue&type=template&id=e8cd43dc&scoped=true&"
import script from "./ModalFrameBasic.vue?vue&type=script&lang=js&"
export * from "./ModalFrameBasic.vue?vue&type=script&lang=js&"
import style0 from "./ModalFrameBasic.vue?vue&type=style&index=0&id=e8cd43dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8cd43dc",
  null
  
)

export default component.exports